import { Button, styled as muiStyled} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../../providers/AuthProvider';

const MenuContainer = styled.nav`
  ul {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
  }
`;
const CustomButton = muiStyled(Button)(({theme}) => ({
  fontFamily: 'GothamBold !important',
  color: 'var(--black)',
  
  '&:hover': {
    backgroundColor: 'var(--gray-300)',
    boxShadow: 'none',
  },
}))

export const Menu = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState('');
  useEffect(() => {
    let mounted = true;
    if ( mounted ) {

      let userName = String(user.name).trim();
      setFirstName(userName.split(' ')[0]);
    }
  
    return () => mounted = false;
  }, [user]);
  
  return (
    <MenuContainer>
      <ul>
        <li>
          <CustomButton onClick={ () => navigate('/regulamento-e-faq')}>Regulamento e FAQ</CustomButton>
        </li>
        <li>
          <CustomButton onClick={ () => navigate('/minha-conta')}>{firstName}</CustomButton>
        </li>
      </ul>
    </MenuContainer>
  )
}
